/** Depop category leaves from the live create-listing Category combobox. */
export const DEPOP_CATEGORY_PATHS = [
  "Everything Else > Home > Home accessories",
  "Everything Else > Tech Accessories > Laptop bags and cases",
  "Everything Else > Tech Accessories > Phone cases",
  "Everything Else > Toys > Dolls and accessories",
  "Kids > Accessories > Bags",
  "Kids > Accessories > Belts",
  "Kids > Accessories > Gloves",
  "Kids > Accessories > Hair accessories",
  "Kids > Accessories > Hats and caps",
  "Kids > Accessories > Jewelry",
  "Kids > Accessories > Other",
  "Kids > Accessories > Scarves and wraps",
  "Kids > Accessories > Sunglasses",
  "Kids > Accessories > Wallets and cardholders",
  "Kids > Accessories > Watches",
  "Kids > Bottoms > Jeans",
  "Kids > Bottoms > Leggings",
  "Kids > Bottoms > Other",
  "Kids > Bottoms > Pants",
  "Kids > Bottoms > Shorts",
  "Kids > Bottoms > Skirts",
  "Kids > Bottoms > Sweatpants",
  "Kids > Coats and Jackets > Coats",
  "Kids > Coats and Jackets > Jackets",
  "Kids > Coats and Jackets > Other",
  "Kids > Coats and Jackets > Vests",
  "Kids > Dresses > Babydoll dresses",
  "Kids > Dresses > Bodycon dresses",
  "Kids > Dresses > Casual dresses",
  "Kids > Dresses > Dresses",
  "Kids > Dresses > Formal dresses",
  "Kids > Dresses > Going out dresses",
  "Kids > Dresses > Other",
  "Kids > Dresses > Prom dresses",
  "Kids > Dresses > Shift dresses",
  "Kids > Dresses > Shirt dresses",
  "Kids > Dresses > Summer dresses",
  "Kids > Dresses > Wedding dresses",
  "Kids > Dresses > Work dresses",
  "Kids > Dresses > Wrap dresses",
  "Kids > Footwear > Baby shoes",
  "Kids > Footwear > Ballet shoes",
  "Kids > Footwear > Boat shoes",
  "Kids > Footwear > Boots",
  "Kids > Footwear > Brogues",
  "Kids > Footwear > Clogs",
  "Kids > Footwear > Espadrilles",
  "Kids > Footwear > Flip flops",
  "Kids > Footwear > Loafers",
  "Kids > Footwear > Mules",
  "Kids > Footwear > Other",
  "Kids > Footwear > Oxfords",
  "Kids > Footwear > Pumps",
  "Kids > Footwear > Sandals",
  "Kids > Footwear > Slides",
  "Kids > Footwear > Slippers",
  "Kids > Footwear > Sneakers",
  "Kids > Jumpsuits and Rompers > Jumpsuits",
  "Kids > Jumpsuits and Rompers > Other",
  "Kids > Jumpsuits and Rompers > Overalls",
  "Kids > Jumpsuits and Rompers > Rompers",
  "Kids > Sleepwear > Other",
  "Kids > Sleepwear > Pajamas",
  "Kids > Sleepwear > Robes",
  "Kids > Suits > Other",
  "Kids > Suits > Suits",
  "Kids > Suits > Tailored jackets",
  "Kids > Suits > Tailored trousers",
  "Kids > Suits > Tuxedos",
  "Kids > Suits > Vests",
  "Kids > Swimwear > Bikini and tankini bottoms",
  "Kids > Swimwear > Bikini and tankini sets",
  "Kids > Swimwear > Bikini and tankini tops",
  "Kids > Swimwear > Cover ups",
  "Kids > Swimwear > Other",
  "Kids > Swimwear > Swim briefs and shorts",
  "Kids > Swimwear > Swimsuits",
  "Kids > Tops > Blouses",
  "Kids > Tops > Bodysuits",
  "Kids > Tops > Cardigans",
  "Kids > Tops > Corsets",
  "Kids > Tops > Crop tops",
  "Kids > Tops > Hoodies",
  "Kids > Tops > Jerseys",
  "Kids > Tops > Other",
  "Kids > Tops > Polo shirts",
  "Kids > Tops > Shirts",
  "Kids > Tops > Sweaters",
  "Kids > Tops > Sweatshirts",
  "Kids > Tops > T-shirts",
  "Kids > Tops > Tank tops and camis",
  "Men > Accessories > Bags",
  "Men > Accessories > Belts",
  "Men > Accessories > Gloves",
  "Men > Accessories > Hair accessories",
  "Men > Accessories > Hats and caps",
  "Men > Accessories > Jewelry",
  "Men > Accessories > Other",
  "Men > Accessories > Scarves and wraps",
  "Men > Accessories > Sunglasses",
  "Men > Accessories > Wallets and cardholders",
  "Men > Accessories > Watches",
  "Men > Bottoms > Jeans",
  "Men > Bottoms > Leggings",
  "Men > Bottoms > Other",
  "Men > Bottoms > Pants",
  "Men > Bottoms > Shorts",
  "Men > Bottoms > Skirts",
  "Men > Bottoms > Sweatpants",
  "Men > Coats and Jackets > Coats",
  "Men > Coats and Jackets > Jackets",
  "Men > Coats and Jackets > Other",
  "Men > Coats and Jackets > Vests",
  "Men > Footwear > Baby shoes",
  "Men > Footwear > Ballet shoes",
  "Men > Footwear > Boat shoes",
  "Men > Footwear > Boots",
  "Men > Footwear > Brogues",
  "Men > Footwear > Clogs",
  "Men > Footwear > Espadrilles",
  "Men > Footwear > Flip flops",
  "Men > Footwear > Loafers",
  "Men > Footwear > Mules",
  "Men > Footwear > Other",
  "Men > Footwear > Oxfords",
  "Men > Footwear > Pumps",
  "Men > Footwear > Sandals",
  "Men > Footwear > Slides",
  "Men > Footwear > Slippers",
  "Men > Footwear > Sneakers",
  "Men > Jumpsuits and Rompers > Jumpsuits",
  "Men > Jumpsuits and Rompers > Other",
  "Men > Jumpsuits and Rompers > Overalls",
  "Men > Jumpsuits and Rompers > Rompers",
  "Men > Sleepwear > Other",
  "Men > Sleepwear > Pajamas",
  "Men > Sleepwear > Robes",
  "Men > Suits > Other",
  "Men > Suits > Suits",
  "Men > Suits > Tailored jackets",
  "Men > Suits > Tailored trousers",
  "Men > Suits > Tuxedos",
  "Men > Suits > Vests",
  "Men > Swimwear > Bikini and tankini bottoms",
  "Men > Swimwear > Bikini and tankini sets",
  "Men > Swimwear > Bikini and tankini tops",
  "Men > Swimwear > Cover ups",
  "Men > Swimwear > Other",
  "Men > Swimwear > Swim briefs and shorts",
  "Men > Swimwear > Swimsuits",
  "Men > Tops > Blouses",
  "Men > Tops > Bodysuits",
  "Men > Tops > Cardigans",
  "Men > Tops > Corsets",
  "Men > Tops > Crop tops",
  "Men > Tops > Hoodies",
  "Men > Tops > Jerseys",
  "Men > Tops > Other",
  "Men > Tops > Polo shirts",
  "Men > Tops > Shirts",
  "Men > Tops > Sweaters",
  "Men > Tops > Sweatshirts",
  "Men > Tops > T-shirts",
  "Men > Tops > Tank tops and camis",
  "Men > Underwear > Bandeaus",
  "Men > Underwear > Boxers and briefs",
  "Men > Underwear > Bras",
  "Men > Underwear > Other",
  "Men > Underwear > Panties",
  "Men > Underwear > Shapewear",
  "Men > Underwear > Socks",
  "Men > Underwear > Tights",
  "Men > Underwear > Undershirts",
  "Women > Accessories > Bags",
  "Women > Accessories > Belts",
  "Women > Accessories > Gloves",
  "Women > Accessories > Hair accessories",
  "Women > Accessories > Hats and caps",
  "Women > Accessories > Jewelry",
  "Women > Accessories > Other",
  "Women > Accessories > Scarves and wraps",
  "Women > Accessories > Sunglasses",
  "Women > Accessories > Wallets and cardholders",
  "Women > Accessories > Watches",
  "Women > Bottoms > Jeans",
  "Women > Bottoms > Leggings",
  "Women > Bottoms > Other",
  "Women > Bottoms > Pants",
  "Women > Bottoms > Shorts",
  "Women > Bottoms > Skirts",
  "Women > Bottoms > Sweatpants",
  "Women > Coats and Jackets > Coats",
  "Women > Coats and Jackets > Jackets",
  "Women > Coats and Jackets > Other",
  "Women > Coats and Jackets > Vests",
  "Women > Dresses > Babydoll dresses",
  "Women > Dresses > Bodycon dresses",
  "Women > Dresses > Casual dresses",
  "Women > Dresses > Dresses",
  "Women > Dresses > Formal dresses",
  "Women > Dresses > Going out dresses",
  "Women > Dresses > Other",
  "Women > Dresses > Prom dresses",
  "Women > Dresses > Shift dresses",
  "Women > Dresses > Shirt dresses",
  "Women > Dresses > Summer dresses",
  "Women > Dresses > Wedding dresses",
  "Women > Dresses > Work dresses",
  "Women > Dresses > Wrap dresses",
  "Women > Footwear > Baby shoes",
  "Women > Footwear > Ballet shoes",
  "Women > Footwear > Boat shoes",
  "Women > Footwear > Boots",
  "Women > Footwear > Brogues",
  "Women > Footwear > Clogs",
  "Women > Footwear > Espadrilles",
  "Women > Footwear > Flip flops",
  "Women > Footwear > Loafers",
  "Women > Footwear > Mules",
  "Women > Footwear > Other",
  "Women > Footwear > Oxfords",
  "Women > Footwear > Pumps",
  "Women > Footwear > Sandals",
  "Women > Footwear > Slides",
  "Women > Footwear > Slippers",
  "Women > Footwear > Sneakers",
  "Women > Jumpsuits and Rompers > Jumpsuits",
  "Women > Jumpsuits and Rompers > Other",
  "Women > Jumpsuits and Rompers > Overalls",
  "Women > Jumpsuits and Rompers > Rompers",
  "Women > Sleepwear > Other",
  "Women > Sleepwear > Pajamas",
  "Women > Sleepwear > Robes",
  "Women > Suits > Other",
  "Women > Suits > Suits",
  "Women > Suits > Tailored jackets",
  "Women > Suits > Tailored trousers",
  "Women > Suits > Tuxedos",
  "Women > Suits > Vests",
  "Women > Swimwear > Bikini and tankini bottoms",
  "Women > Swimwear > Bikini and tankini sets",
  "Women > Swimwear > Bikini and tankini tops",
  "Women > Swimwear > Cover ups",
  "Women > Swimwear > Other",
  "Women > Swimwear > Swim briefs and shorts",
  "Women > Swimwear > Swimsuits",
  "Women > Tops > Blouses",
  "Women > Tops > Bodysuits",
  "Women > Tops > Cardigans",
  "Women > Tops > Corsets",
  "Women > Tops > Crop tops",
  "Women > Tops > Hoodies",
  "Women > Tops > Jerseys",
  "Women > Tops > Other",
  "Women > Tops > Polo shirts",
  "Women > Tops > Shirts",
  "Women > Tops > Sweaters",
  "Women > Tops > Sweatshirts",
  "Women > Tops > T-shirts",
  "Women > Tops > Tank tops and camis",
  "Women > Underwear > Bandeaus",
  "Women > Underwear > Boxers and briefs",
  "Women > Underwear > Bras",
  "Women > Underwear > Other",
  "Women > Underwear > Panties",
  "Women > Underwear > Shapewear",
  "Women > Underwear > Socks",
  "Women > Underwear > Tights",
  "Women > Underwear > Undershirts",
];
